module.exports = __webpack_public_path__ + "img/onboarding2.faee4c5b.png";